import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import Dropdown from "../../components/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
// At the top of your CustomDashboard.js file:
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Import the specific icon object (faFilePdf)
import { faEye, faFileExcel, faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { faRefresh, faSearch, faTicket } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import * as XLSX from "xlsx";
//import PageLoader from "../../components/PageLoader";




const CategoryDashboard = () => {


    // -------------------
    // AUTO YEARS
    // -------------------
    const currentYear = new Date().getFullYear();

    const years = Array.from({ length: 3 }, (_, i) => currentYear - i).map(
        (y) => ({ label: String(y), value: y })
    );
    const [allUserData, setAllUserData] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState({});

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
    ].map((m, i) => ({
        label: m,
        value: (i + 1).toString(),   // <-- No padStart
    }));


    const [categories, setCategories] = useState([
        { "value": 1, "label": "ECU Tuning" },
        { "value": 2, "label": "Diesel Injection Pump Repair" },
        { "value": 3, "label": "Climate Control Unit Repair" },
        { "value": 4, "label": "Turbo Actuator Repair" },
        { "value": 5, "label": "Power Steering Repair" },
        { "value": 6, "label": "Gear Lever Repair" },
        { "value": 7, "label": "Instrument Cluster Repair" },
        { "value": 8, "label": "Immobiliser Removing" },
        { "value": 9, "label": "Immobiliser Repair" },
        { "value": 10, "label": "Airbag Reset" },
        { "value": 11, "label": "ABS Pump Repair" },
        { "value": 12, "label": "BSI Repair" },
        { "value": 13, "label": "ECU Repair" },
        { "value": 14, "label": "EIS/ESL Repair" },
        { "value": 15, "label": "FRM Repair" },
        { "value": 16, "label": "Radio/CD/Navigation Repair" },
        { "value": 17, "label": "Remote Repair" },
        { "value": 18, "label": "TCU Repair" },
        { "value": 19, "label": "Other" }
    ]);
    const [selectedNames, setSelectedNames] = useState([]);
    const [selectedMonths, setSelectedMonths] = useState([]);

    const [rangeType, setRangeType] = useState("year");
    const [dynamicValue, setDynamicValue] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [searchText, setSearchText] = useState("");



    const now = new Date();
    const timestamp =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0") +
        "_" +
        now.getHours().toString().padStart(2, "0") +
        "-" +
        now.getMinutes().toString().padStart(2, "0") +
        "-" +
        now.getSeconds().toString().padStart(2, "0");




    // Date limits for last 3 months only
    const today = new Date();

    // Max allowed date = today
    const maxDate = today.toISOString().split("T")[0];

    // Min allowed date = today minus 3 months
    const last3 = new Date();
    last3.setMonth(last3.getMonth() - 3);
    const minDate = last3.toISOString().split("T")[0];


    // Normalize dropdown data
    const normalizeOption = (opt) => {
        if (!opt) return null;
        if (typeof opt === "object") return opt;
        return { label: String(opt), value: opt };
    };

    const handleRangeTypeChange = (e) => {
        const normalized = normalizeOption(e);
        setRangeType(normalized?.value || "year");

        setDynamicValue(null);
        setSelectedMonths([]);
        setStartDate("");
        setEndDate("");
    };

    const handleDynamicChange = (e) => {
        setDynamicValue(normalizeOption(e));
    };

    const headerLabels = {
        year: "Year",
        job_type: "Market Area",
        report_month: "Month",
        start_date: "Start Date",
        end_date: "End Date",
        jobs: "Jobs",
        reworkjobs: "Rework Jobs",
        revenue: "Revenues (£)",
        cost: "Costs (£)",
        gross_profit: "Gross Profit(£)",
        gp_percent: "GP (%)",
        avg_revenue_per_job: "Avg (£/Job)"
    };


    const exportExcel = (data) => {
        if (!data || data.length === 0) return alert("No data to export.");

        const visibleCols = Object.keys(visibleColumns).filter(
            (col) => visibleColumns[col]
        );

        const formattedHeaders = visibleCols.map((col) =>
            columnNameMap[col]
                ? columnNameMap[col]
                : col.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
        );

        const exportData = data.map((row) =>
            visibleCols.reduce((acc, col, idx) => {
                acc[formattedHeaders[idx]] = row[col];
                return acc;
            }, {})
        );

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

        XLSX.writeFile(workbook, `report-${timestamp}.xlsx`);
    };


    const exportPDF = (data) => {
        if (!data || data.length === 0) return alert("No data to export.");

        const formattedHeaders = Object.keys(data[0]).map((col) =>
            columnNameMap[col]
                ? columnNameMap[col]
                : col.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
        );

        const html = `
    <html>
    <head>
      <title>Report</title>
      <style>
        table { width: 100%; border-collapse: collapse; }
        th, td { border: 1px solid #555; padding: 8px; font-size: 12px; }
        th { background: #eee; }
      </style>
    </head>
    <body>
      <h2>Report</h2>
      <table>
        <thead>
          <tr>${formattedHeaders.map((h) => `<th>${h}</th>`).join("")}</tr>
        </thead>
        <tbody>
          ${data
                .map(
                    (row) =>
                        `<tr>${Object.keys(row)
                            .map((col) => `<td>${row[col]}</td>`)
                            .join("")}</tr>`
                )
                .join("")}
        </tbody>
      </table>
    </body>
    </html>
  `;

        const newWindow = window.open("", "_blank");
        newWindow.document.write(html);
        newWindow.print();
    };



    // COPY TO CLIPBOARD
    const copyTable = () => {
        const visibleCols = Object.keys(visibleColumns).filter(c => visibleColumns[c]);

        // Header row with labels
        const headerRow = visibleCols.map(c => headerLabels[c] || c).join("\t");

        // Data rows
        const dataRows = tableData
            .map(row => visibleCols.map(c => row[c]).join("\t"))
            .join("\n");

        const text = headerRow + "\n" + dataRows;

        navigator.clipboard.writeText(text);
        alert("Copied!");
    };


    // CSV EXPORT
    const exportCSV = () => {
        const visibleCols = Object.keys(visibleColumns).filter(c => visibleColumns[c]);

        // Use label mapping instead of raw keys
        const headerRow = visibleCols
            .map((c) => headerLabels[c] || c)
            .join(",");

        const dataRows = tableData
            .map((row) =>
                visibleCols
                    .map((c) => {
                        let cell = row[c] ?? "";

                        // Escape commas, quotes for CSV safety
                        if (typeof cell === "string" && (cell.includes(",") || cell.includes('"'))) {
                            cell = `"${cell.replace(/"/g, '""')}"`;
                        }

                        return cell;
                    })
                    .join(",")
            )
            .join("\n");

        const csv = headerRow + "\n" + dataRows;

        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `report-${timestamp}.csv`;
        link.click();
    };


    // PRINT PAGE
    const printTable = () => {
        window.print();
    };


    const validateInputs = () => {
        if (selectedNames.length === 0) {
            alert("Please select at least one Category.");
            return false;
        }

        if (rangeType === "year" && !dynamicValue) {
            alert("Please select a Year.");
            return false;
        }

        if (rangeType === "month") {
            if (!dynamicValue) {
                alert("Please select a Year.");
                return false;
            }
            if (selectedMonths.length === 0) {
                alert("Please select Month(s).");
                return false;
            }
        }

        if (rangeType === "custom") {
            if (!startDate) return alert("Please select Start Date.");
            if (!endDate) return alert("Please select End Date.");
            if (startDate > endDate) return alert("End must be greater.");
        }

        return true;
    };

    const resetData = () => {
        // 1. Clear Multi-Selects
        setSelectedNames([]);
        setSelectedMonths([]);

        // 2. Reset Range/Date Inputs
        setRangeType("year");
        setDynamicValue(null);
        setStartDate("");
        setEndDate("");

        // 3. Clear Results
        setTableData([]);
        setCurrentPage(1);
    };


    const searchData = async () => {
        if (!validateInputs()) return;

        setLoading(true);

        // const empIds = selectedNames.map((e) => e.value);
        // const empIds = selectedNames.map(e => e.value).join(",");


        let payload = {
            //   empIds: empIds,
            //rangeType: rangeType,
            in_year: null,
            months_ids: null,
            startDate: null,
            endDate: null,
        };

        //   {
        //   empIds: "118557,71041",
        //   months_ids: "",
        //   in_year: "",
        //   startDate:"2025-11-01",
        //   endDate:"2025-11-30"
        // }

        if (rangeType === "year") {
            payload.in_year = dynamicValue?.value;
        }

        if (rangeType === "month") {
            payload.in_year = dynamicValue?.value;
            payload.months_ids = selectedMonths.map((m) => m.value).join(",");;
        }

        if (rangeType === "custom") {
            payload.startDate = startDate;
            payload.endDate = endDate;
        }

        //console.log("Payload:", payload);

        try {
            const response = await axios.post(`https://api.autotronicsuk.com/api/category/performance`, payload);

            let apiData = [];

            if (Array.isArray(response.data)) {
                apiData = response.data;
            } else if (Array.isArray(response.data.data)) {
                apiData = response.data.data;
            } else if (Array.isArray(response.data.result)) {
                apiData = response.data.result;
            } else {
                console.error("Unknown API format:", response.data);
            }

            console.log("apiData Data:", apiData);
            // Map selected categories to API data
            // Extract category labels from selectedNames
            const selectedCategoryLabels = selectedNames.map(cat => cat.label);

            let finalData = [];

            // If multiple months selected, show all category-month combinations
            if (rangeType === "month" && selectedMonths.length > 1) {
                const selectedMonthValues = selectedMonths.map(m => m.value);
                
                // For each category and each month, create a row
                selectedCategoryLabels.forEach(categoryLabel => {
                    selectedMonthValues.forEach(monthValue => {
                        // Find matching row from API
                        const matchingRow = apiData.find(row =>
                            row.job_type === categoryLabel &&
                            row.report_month === months.find(m => m.value === monthValue)?.label
                        );
                        
                        if (matchingRow) {
                            finalData.push(matchingRow);
                        } else {
                            // Create placeholder for missing category-month combination
                            const monthLabel = months.find(m => m.value === monthValue)?.label || "";
                            finalData.push({
                                job_type: categoryLabel,
                                year: dynamicValue?.value || "",
                                report_month: monthLabel,
                                start_date: startDate || "",
                                end_date: endDate || "",
                                jobs: 0,
                                reworkjobs: 0,
                                revenue: 0,
                                cost: 0,
                                gross_profit: 0,
                                gp_percent: 0,
                                avg_revenue_per_job: 0,
                            });
                        }
                    });
                });
            } else {
                // Single month or year/custom range - original logic
                const mappedData = selectedCategoryLabels.map(categoryLabel => {
                    const categoryRows = apiData.filter(row => row.job_type === categoryLabel);
                    
                    if (categoryRows.length > 0) {
                        return categoryRows[0];
                    } else {
                        return {
                            job_type: categoryLabel,
                            year: dynamicValue?.value || "",
                            report_month: selectedMonths.map(m => m.label).join(", ") || "",
                            start_date: startDate || "",
                            end_date: endDate || "",
                            jobs: 0,
                            reworkjobs: 0,
                            revenue: 0,
                            cost: 0,
                            gross_profit: 0,
                            gp_percent: 0,
                            avg_revenue_per_job: 0,
                        };
                    }
                });
                finalData = mappedData;
            }

            console.log("Mapped Data:", finalData);
            setTableData(finalData);
            setCurrentPage(1);
        } catch (error) {
            console.error("API Error:", error);
            alert("Something went wrong while fetching data!");
        } finally {
            setLoading(false);
        }
    };



    const getDateRangeForRow = (row) => {
        let start = null;
        let end = null;

        if (rangeType === "year") {
            // Entire selected year
            const year = dynamicValue?.value;
            start = `${year}-01-01`;
            end = `${year}-12-31`;
        }

        if (rangeType === "month") {
            const year = dynamicValue?.value;

            // User selected multiple months (take min & max)
            const selected = selectedMonths.map(m => Number(m.value));

            const minMonth = Math.min(...selected);
            const maxMonth = Math.max(...selected);

            start = `${year}-${minMonth}-01`;

            // Calculate last day of max month
            const lastDay = new Date(year, maxMonth, 0).getDate();
            end = `${year}-${maxMonth}-${lastDay}`;
        }

        if (rangeType === "custom") {
            start = startDate;
            end = endDate;
        }

        return { start, end };
    };


    const handleView = (row) => {
        //console.log(allUserData);
        const clickuser = allUserData
            .filter((u) => u.empid == row.emp_id)
            .map((u) => ({
                uname: u.u_name,
                empid: u.empid,
                empemail: u.email,
            }));
        localStorage.setItem("clickUserDetail", JSON.stringify(clickuser));
        //console.log("row",clickuser);
        const { start, end } = getDateRangeForRow(row);
        // Prepare payload for new page
        const payload = {
            empId: row.emp_id,
            startDate: row.start_date,
            endDate: row.end_date,
        };

        // Store payload in localStorage so new tab can read it
        localStorage.setItem("viewPayload", JSON.stringify(payload));

        // Open new tab
        window.open("/view-details", "_blank");
    };

    const columnNameMap = {
        total_rs_tickets: "Total Job Completed Ticket",
        total_reworks: "Total Rework Ticket",
        engineer_turnover: "Eng Job Completed",
        engineer_costs: "Part Cost for Eng",
        amount_refunded: "Refund Amount for Eng"
    };
    // -----------------------------------------
    // REQUIRED STATES (Fix ESLint errors)
    // -----------------------------------------

    const [searchTerm, setSearchTerm] = useState("");

    const [recordsPerPage, setRecordsPerPage] = useState(20);

    //const totalPages = Math.ceil(sortedData.length / recordsPerPage);


    const toggleColumn = (col) => {
        setVisibleColumns((prev) => ({
            ...prev,
            [col]: !prev[col],
        }));
    };




    //
    // Add this function inside the Dashboard component,
    // for example, before the searchData function.


    // Generate dynamic headers
    const generateHeaders = () =>
        tableData.length > 0 ? Object.keys(tableData[0]) : [];

    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;



    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: "asc",
    });

    const handleSort = (column) => {
        let direction = "asc";

        if (sortConfig.key === column && sortConfig.direction === "asc") {
            direction = "desc";
        }

        setSortConfig({ key: column, direction });
    };

    const filteredData = tableData.filter((row) => {
        const rowValues = Object.values(row)
            .map(v => (v ?? "").toString().toLowerCase())
            .join(" ");

        return rowValues.includes(searchText.toLowerCase());
    });




    // ------------------------------
    // SORTED DATA (NEW)
    // ------------------------------
    const sortedData = React.useMemo(() => {
        if (!sortConfig.key) return filteredData;

        const sorted = [...filteredData].sort((a, b) => {
            let valueA = a[sortConfig.key];
            let valueB = b[sortConfig.key];

            if (valueA === null || valueA === undefined) valueA = "";
            if (valueB === null || valueB === undefined) valueB = "";

            // Convert numbers correctly
            const isNumber =
                !isNaN(Number(valueA)) &&
                !isNaN(Number(valueB)) &&
                valueA !== "" &&
                valueB !== "";

            if (isNumber) {
                valueA = Number(valueA);
                valueB = Number(valueB);
            } else {
                valueA = valueA.toString().toLowerCase();
                valueB = valueB.toString().toLowerCase();
            }

            if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
            if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
        });

        return sorted;
    }, [filteredData, sortConfig]);

    // ------------------------------
    // PAGINATION (FIXED: use sortedData)
    // ------------------------------

    const paginatedData = sortedData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const totalPages = Math.ceil(sortedData.length / recordsPerPage) || 1;

    const poundColumns = [
        "revenue",
        "cost",
        "gross_profit",
        "avg_revenue_per_job",
    ];

    // Columns that should display a percentage sign (no calculation)
    const percentColumns = [
        "gp_percent",       // adjust name to your actual API key if different // show as percentage
    ];


    const formatPound = (x) =>
        new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(Number(x));



    // -------------------
    // RENDER UI
    // -------------------

    useEffect(() => {
        // fetchEmployees();
        if (tableData.length > 0) {
            const cols = Object.keys(tableData[0]);
            const visibilityMap = {};
            cols.forEach(col => (visibilityMap[col] = true));
            setVisibleColumns(visibilityMap);
        }

    }, [tableData])

    // add near the top of the component (before render) or just above return
    const getAllColumns = () => {
        const colsFromVisible = Object.keys(visibleColumns || {});
        const colsFromData = tableData.length > 0 ? Object.keys(tableData[0]) : [];
        // union and preserve order: data keys first, then any extras from visibleColumns
        const union = [...new Set([...colsFromData, ...colsFromVisible])];
        return union;
    };

    useEffect(() => {
        // ensure currentPage is valid when data or page size changes
        const newTotal = Math.max(1, Math.ceil(sortedData.length / recordsPerPage));
        setCurrentPage((p) => Math.min(p, newTotal));
    }, [sortedData.length, recordsPerPage]);

    // Build compact page list with ellipses
    const getPageItems = (total, current, maxButtons = 7) => {
        if (total <= maxButtons) return Array.from({ length: total }, (_, i) => i + 1);

        const pages = [];
        const side = Math.floor((maxButtons - 3) / 2); // reserve first, last and two ellipses
        let start = Math.max(2, current - side);
        let end = Math.min(total - 1, current + side);

        if (current - 1 <= side) {
            start = 2;
            end = maxButtons - 2;
        } else if (total - current <= side) {
            start = total - (maxButtons - 3);
            end = total - 1;
        }

        pages.push(1);
        if (start > 2) pages.push("left-ellipsis");
        for (let p = start; p <= end; p++) pages.push(p);
        if (end < total - 1) pages.push("right-ellipsis");
        pages.push(total);
        return pages;
    };

    const scrollToTableTop = () => {
        const el = document.querySelector(".table-card");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const onSetPage = (page) => {
        if (page < 1 || page > totalPages || page === currentPage) return;
        setCurrentPage(page);
        scrollToTableTop();
    };


    return (

        <div className="container mt-4">
            <div className="card p-3 shadow-sm">

                <h4>Category Figures(Market Area Cards)</h4>
                <h5 className="fw-bold mb-3">Search Filters</h5>
                <div className="row g-3 align-items-end">

                    <div className="col-md-3 mb-2">
                        <label className="form-label fw-bold">Categories *</label>
                        <MultiSelect
                            options={categories}
                            value={selectedNames}
                            onChange={setSelectedNames}
                            labelledBy="Select Categories"
                        />
                    </div>

                    <div className="col-md-3">
                        <Dropdown
                            label="Range Type *"
                            value={rangeType}
                            onChange={handleRangeTypeChange}
                            options={[
                                { label: "Year", value: "year" },
                                { label: "Month", value: "month" },
                                { label: "Custom", value: "custom" },
                            ]}
                        />
                    </div>

                    <div className={rangeType === "custom" ? "col-md-4" : "col-md-3"}>
                        {rangeType === "year" && (
                            <Dropdown
                                label="Select Year *"
                                value={dynamicValue}
                                onChange={handleDynamicChange}
                                options={years}
                            />
                        )}

                        {rangeType === "month" && (
                            <div className="row g-2">
                                <div className="col-md-6">
                                    <Dropdown
                                        label="Select Year *"
                                        value={dynamicValue}
                                        onChange={handleDynamicChange}
                                        options={years}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label fw-bold">Select Month *</label>
                                    <MultiSelect
                                        options={months}
                                        value={selectedMonths}
                                        onChange={setSelectedMonths}
                                        labelledBy="Month"
                                    />
                                </div>
                            </div>
                        )}

                        {rangeType === "custom" && (
                            <div className="row g-2">
                                <div className="col-md-6 mt-3">
                                    <label className="small fw-bold">Start Date *</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={startDate}
                                        min={minDate}     // ⬅ LIMIT START DATE
                                        max={maxDate}     // ⬅ LIMIT START DATE
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </div>

                                <div className="col-md-6 mt-3">
                                    <label className="small fw-bold">End Date *</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={endDate}
                                        min={minDate}     // ⬅ LIMIT START DATE
                                        max={maxDate}     // ⬅ LIMIT START DATE
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="col-md-2 d-flex justify-content-center mb-2">
                        <button
                            className="btn btn-primary w-50 me-2 btn-md"
                            onClick={searchData}
                            disabled={loading}
                        >
                            <FontAwesomeIcon className="fa-lg me-1" icon={faSearch} />
                        </button>

                        <button
                            className="btn btn-secondary w-50 btn-md"
                            onClick={resetData}
                            disabled={loading}
                        >
                            <FontAwesomeIcon className="fa-lg me-1" icon={faRefresh} />
                        </button>
                    </div>
                </div>

            </div>

            {/* TABLE */}
            {tableData.length > 0 && (
                <div className="card mt-4 p-3 shadow-sm position-relative table-card">

                    {/* Loader overlay shown while loading data */}
                    {loading && (
                        <div
                            className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                            style={{ background: "rgba(255,255,255,0.75)", zIndex: 2000 }}
                        >
                            <div className="spinner-border text-primary" role="status" aria-hidden="true">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}


                    {/* HEADER BUTTONS + SEARCH */}
                    <div className="d-flex justify-content-between align-items-center mb-3">

                        <div className="d-flex align-items-center gap-3">
                            {/* Button Group */}
                            <div className="btn-group" role="group">
                                <button className="btn btn-secondary btn-sm" onClick={() => exportExcel(tableData)}>
                                    Excel
                                </button>

                                <button className="btn btn-secondary btn-sm" onClick={() => exportPDF(tableData)}>
                                    PDF
                                </button>

                                {/* Column Visibility */}
                                <div className="btn-group" role="group">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                    >
                                        Columns
                                    </button>

                                    <ul className="dropdown-menu">
                                        {getAllColumns()
                                            .map((col, i) => (
                                                <li key={i}>
                                                    <div className="dropdown-item">
                                                        <input
                                                            type="checkbox"
                                                            checked={!!visibleColumns[col]}          // ensure boolean
                                                            onChange={() => toggleColumn(col)}
                                                            className="me-2"
                                                        />
                                                        {columnNameMap[col]
                                                            ? columnNameMap[col]
                                                            : headerLabels[col]}
                                                    </div>
                                                </li>
                                            ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* TABLE */}
                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: "60vh", // adjust as needed
                            whiteSpace: "nowrap",
                        }}
                    >
                        <table className="table table-bordered table-striped mt-2">
                            <thead className="table-dark">
                                <tr>
                                    
                                    {/* OTHER DYNAMIC COLUMNS */}
                                    {Object.keys(visibleColumns)
                                        .filter(col => visibleColumns[col])
                                        .map((col, index) => (
                                            <th key={index} className={col === "job_type" ? "sticky-left-1 w-100" : ""}>
                                                {columnNameMap[col]
                                                    ? columnNameMap[col]
                                                    : headerLabels[col]}
                                            </th>
                                        ))}
                                </tr>
                            </thead>


                            <tbody>
                                {paginatedData.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {Object.keys(row)
                                            .filter(col => visibleColumns[col])
                                            .map((col, colIndex) => {

                                                const isCurrency = poundColumns.includes(col);
                                                const isPercent = percentColumns.includes(col);

                                                // apply sticky class to Emp Id and Employee Name cells
                                                const tdClass =
                                                    col === "emp_id" ? "sticky-left-1" :
                                                        col === "job_type" ? "sticky-left-1" : "";

                                                // render value
                                                const raw = row[col];
                                                let display;
                                                if (raw === null || raw === undefined || raw === "") {
                                                    display = "-";
                                                } else if (isPercent) {
                                                    const s = String(raw).trim();
                                                    display = s.endsWith("%") ? s : `${s}%`;
                                                } else if (isCurrency) {
                                                    display = formatPound(raw);
                                                } else {
                                                    display = raw;
                                                }

                                                return (
                                                    <td key={colIndex} className={tdClass}>
                                                        {display}
                                                    </td>
                                                );
                                            })}
                                    </tr>

                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* PAGINATION - improved with ellipses */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <nav aria-label="Table pagination">
                            <ul className="pagination mb-0">
                                <li className={`page-item ${currentPage === 1 || loading ? "disabled" : ""}`}>
                                    <button className="page-link" onClick={() => onSetPage(currentPage - 1)} aria-label="Previous">
                                        Prev
                                    </button>
                                </li>

                                {getPageItems(totalPages, currentPage).map((item, idx) => {
                                    if (item === "left-ellipsis" || item === "right-ellipsis") {
                                        return (
                                            <li key={item + idx} className="page-item disabled">
                                                <span className="page-link">…</span>
                                            </li>
                                        );
                                    }
                                    return (
                                        <li key={item} className={`page-item ${currentPage === item ? "active" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => onSetPage(item)}
                                                aria-current={currentPage === item ? "page" : undefined}
                                            >
                                                {item}
                                            </button>
                                        </li>
                                    );
                                })}

                                <li className={`page-item ${currentPage === totalPages || loading ? "disabled" : ""}`}>
                                    <button className="page-link" onClick={() => onSetPage(currentPage + 1)} aria-label="Next">
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>

                        <div className="d-flex align-items-center gap-2">
                            <label className="small text-muted mb-0">Rows</label>
                            <select
                                className="form-select form-select-sm"
                                value={recordsPerPage}
                                onChange={(e) => {
                                    const val = Number(e.target.value) || 10;
                                    setRecordsPerPage(val);
                                    setCurrentPage(1);
                                    scrollToTableTop();
                                }}
                                style={{ width: 90 }}
                                disabled={loading}
                            >
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                            </select>
                        </div>
                    </div>
                </div>
            )}






        </div>
    );

};

export default CategoryDashboard;
